export interface PwaReward {
	rewardId: string;
	rewardDate: Date;
}

export interface PWARewardResponse {
	success?: boolean;
	rewardId?: string;
}

export interface PWARewardLaunchResponse {
	success?: boolean;
	pwaReward?: PwaReward;
}

export interface PWARewardStatusResponse {
	success?: boolean;
	pwaReward?: PwaReward;
}

export type PushLocalState = {
	everEnabled?: boolean;
	// When we detected a transition from enabled -> disabled (epoch ms)
	disabledAt?: number | null;
	// User explicitly chose "Not now" on our opt-in popup
	neverShowPopup?: boolean;
	// We already auto-showed the initial opt-in popup once
	initialPopupShown?: boolean;
};

export const PUSH_LOCAL_STATE_KEY = "store.solitairetripeaks.com:pwaPushState";
